import Intercom from "@intercom/messenger-js-sdk";

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;

const IntercomChat = () => {
  Intercom({
    app_id: INTERCOM_APP_ID!,
    language_override: "pt-BR",
    page_title: document.title,
  });

  return <></>;
};

export { IntercomChat };
